// extracted by mini-css-extract-plugin
export var buttons = "_ap-0";
export var buttonsActive = "_ap-h";
export var cancelConfirm = "_ap-1";
export var closeButton = "_ap-2";
export var column = "_ap-3";
export var container = "_ap-4";
export var detailHeader = "_ap-6";
export var detailTitle = "_ap-7";
export var detailsContent = "_ap-5";
export var header = "_ap-8";
export var headerWithClose = "_ap-9";
export var icon = "_ap-a";
export var infoIcon = "_ap-c";
export var informationContainer = "_ap-b";
export var sideDrawer = "_ap-d";
export var sideDrawerOpen = "_ap-e";
export var stickyFooter = "_ap-f";
export var typeOption = "_ap-g";